var _defs, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7b4b1d2a31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 113 114 L 224 114 L 224 222 L 113 222 Z M 113 114 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1ec7abd0bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 151.753906 134.105469 C 151.753906 124.132812 154.492188 118.710938 169.589844 116.125 C 179.839844 114.371094 192.984375 114.148438 205.242188 116.125 C 214.925781 117.6875 223.078125 124.742188 223.078125 134.105469 L 223.078125 167 C 223.078125 176.648438 215.164062 184.550781 205.242188 184.550781 L 169.589844 184.550781 C 157.488281 184.550781 147.289062 194.636719 147.289062 206.039062 L 147.289062 221.824219 L 135.03125 221.824219 C 124.660156 221.824219 118.625 214.511719 116.085938 204.285156 C 112.667969 190.542969 112.8125 182.355469 116.085938 169.191406 C 118.925781 157.710938 128.003906 151.652344 138.375 151.652344 L 187.421875 151.652344 L 187.421875 147.261719 L 151.753906 147.261719 L 151.753906 134.101562 Z M 151.753906 134.105469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 812.246475,
    gradientTransform: "matrix(0.748611, 0, 0, 0.731898, -384.444416, -264.407404)",
    y1: 574.905751,
    x2: 663.592192,
    gradientUnits: "userSpaceOnUse",
    y2: 573.716639,
    id: "c700ef1db6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 41.598511%, 58.799744%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 41.677856%, 58.935547%)",
    offset: 0.00791584
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 41.757202%, 59.072876%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 41.850281%, 59.234619%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 42.037964%, 59.559631%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 42.225647%, 59.883118%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 42.41333%, 60.206604%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 42.601013%, 60.53009%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 42.78717%, 60.855103%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 42.974854%, 61.178589%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 43.162537%, 61.502075%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 43.35022%, 61.827087%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 43.537903%, 62.150574%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 43.72406%, 62.47406%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 43.911743%, 62.799072%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 44.099426%, 63.122559%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 44.287109%, 63.446045%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 44.474792%, 63.769531%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 44.66095%, 64.094543%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 44.848633%, 64.41803%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 45.036316%, 64.741516%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 45.223999%, 65.066528%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 45.411682%, 65.390015%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 45.597839%, 65.713501%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 45.785522%, 66.038513%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 45.973206%, 66.362%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 46.160889%, 66.685486%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 46.348572%, 67.008972%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 46.534729%, 67.333984%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 46.722412%, 67.657471%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 46.910095%, 67.980957%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 47.097778%, 68.305969%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 47.285461%, 68.629456%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 47.438049%, 68.894958%)",
    offset: 0.992084
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 47.499084%, 68.998718%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d4651013fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 151 151 L 262 151 L 262 260 L 151 260 Z M 151 151 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d6b9cc8d86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 223.074219 239.371094 C 223.074219 249.34375 214.226562 254.394531 205.242188 256.910156 C 191.730469 260.710938 180.882812 260.128906 169.589844 256.910156 C 160.15625 254.226562 151.753906 248.738281 151.753906 239.371094 L 151.753906 206.476562 C 151.753906 197.011719 159.828125 188.925781 169.589844 188.925781 L 205.242188 188.925781 C 217.117188 188.925781 227.542969 178.890625 227.542969 166.996094 L 227.542969 151.652344 L 240.910156 151.652344 C 251.292969 151.652344 256.183594 159.195312 258.742188 169.191406 C 262.308594 183.078125 262.46875 193.460938 258.742188 204.285156 C 255.136719 214.796875 251.28125 221.824219 240.910156 221.824219 L 187.414062 221.824219 L 187.414062 226.214844 L 223.070312 226.214844 L 223.070312 239.375 Z M 223.074219 239.371094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 864.150986,
    gradientTransform: "matrix(0.748611, 0, 0, 0.731898, -384.444416, -264.407404)",
    y1: 642.17999,
    x2: 716.258961,
    gradientUnits: "userSpaceOnUse",
    y2: 642.17999,
    id: "5883cf6972"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.399658%, 21.199036%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.471375%, 21.334839%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.642273%, 21.661377%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.843689%, 22.042847%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.045105%, 22.424316%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.246521%, 22.805786%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.447937%, 23.187256%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.647827%, 23.568726%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.849243%, 23.950195%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.050659%, 24.331665%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.252075%, 24.713135%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.453491%, 25.094604%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.653381%, 25.476074%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.854797%, 25.857544%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.056213%, 26.239014%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.257629%, 26.620483%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.459045%, 27.001953%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.658936%, 27.383423%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.860352%, 27.764893%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.061768%, 28.146362%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.263184%, 28.527832%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.4646%, 28.909302%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.666016%, 29.290771%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.865906%, 29.672241%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.067322%, 30.053711%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.268738%, 30.435181%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.470154%, 30.81665%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.67157%, 31.19812%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.87146%, 31.581116%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.072876%, 31.962585%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.274292%, 32.344055%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.475708%, 32.725525%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.677124%, 33.106995%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7b4b1d2a31)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ec7abd0bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c700ef1db6)",
    d: "M 112.667969 114.148438 L 112.667969 221.824219 L 223.078125 221.824219 L 223.078125 114.148438 Z M 112.667969 114.148438 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d4651013fc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d6b9cc8d86)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#5883cf6972)",
    d: "M 151.753906 151.652344 L 151.753906 260.710938 L 262.46875 260.710938 L 262.46875 151.652344 Z M 151.753906 151.652344 ",
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 160.671875 131.914062 C 160.671875 128.273438 163.65625 125.328125 167.355469 125.328125 C 171.042969 125.328125 174.042969 128.273438 174.042969 131.914062 C 174.042969 135.546875 171.042969 138.488281 167.355469 138.488281 C 163.660156 138.488281 160.671875 135.546875 160.671875 131.914062 Z M 200.789062 241.554688 C 200.789062 237.921875 203.789062 234.980469 207.476562 234.980469 C 211.171875 234.980469 214.160156 237.925781 214.160156 241.554688 C 214.160156 245.195312 211.175781 248.140625 207.476562 248.140625 C 203.789062 248.140625 200.789062 245.195312 200.789062 241.554688 Z M 200.789062 241.554688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.c911a71ff524a5877e63c40b3813b02e.svg";
export { ForwardRef as ReactComponent };